var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 60,
    viewBox: "0 0 54 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 58C52 49.4089 40.8071 42.4444 27 42.4444C13.1929 42.4444 2 49.4089 2 58M27 33.1111C18.3705 33.1111 11.375 26.1467 11.375 17.5556C11.375 8.96446 18.3705 2 27 2C35.6295 2 42.625 8.96446 42.625 17.5556C42.625 26.1467 35.6295 33.1111 27 33.1111Z",
    stroke: "#E3E8FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconSvg);
export default __webpack_public_path__ + "static/media/profileIconSVG.781fff7e78d774ec6efa54e81c3af8c3.svg";
export { ForwardRef as ReactComponent };